define([
	"dojo/_base/declare",
	"csi/heading/RefImage",
	"csi/xml"
], function(declare,RefImage,xml) {

	return declare(RefImage, {
		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if image does not exist on context, then move to ColorSpecification (if different than context)
			var	color = ctx.getNode();

			if (color && (color.ColorSpecification != color.$URL) && !xml.isValidURL(this._getValue(ctx, h))) {
				ctx.pushParams().setNodeURL(color.ColorSpecification);
				ctx.__popContext = true;
				ctx.__popKeyValue = ctx.keyValue;
                ctx.keyValue = "";
			}

			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context if pushed above
			if (ctx.__popContext) {
				ctx.__popContext = false;
				ctx.keyValue = ctx.__popKeyValue;
				ctx.pop();
			}

			this.inherited(arguments);
		}
	});
});